export const FAQ_LIST = [
  {
    title: "What Is a Crypto vIBAN Account?",
    content: (
      <>
        <p>
          A Crypto IBAN account is a modern financial solution that combines the flexibility of cryptocurrency with the structure of
          traditional banking. It provides you with a dedicated IBAN (International Bank Account Number) that can be funded directly with
          crypto assets like BTC, ETH, or USDT.
        </p>
        <p>Once crypto is sent, it’s automatically converted into fiat currency (such as EUR or USD), allowing you to:</p>
        <p className="list">Send and receive SEPA or SWIFT payments</p>
        <p className="list">Pay suppliers, salaries, or invoices</p>
        <p className="list">Withdraw to other bank accounts</p>
        <p className="list">Use your digital assets in the real-world economy</p>
        <p>
          This account type is ideal for individuals and businesses operating in the digital economy, offering speed, global access, and
          crypto-to-fiat convenience — all in one account.
        </p>
      </>
    ),
  },
  {
    title: "Who Can Use a Crypto IBAN Account?",
    content: (
      <>
        <p>
          Crypto IBAN accounts are designed for a wide range of users who need a flexible bridge between digital assets and traditional
          finance:
        </p>
        <p className="list">Freelancers & Digital Nomads</p>
        <span>Get paid in crypto, convert to fiat, and withdraw or spend globally.</span>
        <p className="list">Remote Professionals & Consultants</p>
        <span>Receive international payments from clients and agencies via SEPA/SWIFT.</span>
        <p className="list">Crypto Traders & Investors</p>
        <span>Easily cash out earnings and access them through a dedicated IBAN.</span>
        <p className="list">IT & Web3 Companies</p>
        <span>Manage revenue, payroll, and vendor payments using crypto or fiat — all in one account.</span>
        <p className="list">Startups & SMEs</p>
        <span>Simplify treasury management by accepting crypto and sending global payments without legacy banking delays.</span>
        <p>
          If you’re part of the digital economy, a crypto IBAN account gives you global reach, fast access, and full control over your
          funds.
        </p>
      </>
    ),
  },
  {
    title: "Benefits of a Crypto IBAN Account",
    content: (
      <>
        <p className="list">Crypto-to-Fiat Conversion</p>
        <span>Easily top up your account with BTC, ETH, USDT, and more — funds are automatically converted into fiat (EUR, USD, GBP).</span>
        <p className="list">Dedicated IBAN in Your Name</p>
        <span>
          Receive a personal or business IBAN you can use just like a traditional bank account — for SEPA/SWIFT transfers, invoicing, and
          payouts.
        </span>
        <p className="list">Global Payments Made Simple</p>
        <span>Send and receive international payments seamlessly without the slow processes of traditional banking.</span>
        <p className="list">Borderless Finance</p>
        <span>Perfect for remote work, digital nomads, freelancers, and crypto-native businesses — access your money from anywhere.</span>
        <p className="list">Fast Onboarding</p>

        <span>Quick and easy account setup for both individuals and companies, with minimal paperwork and full compliance.</span>
        <p className="list">Secure & Regulated</p>
        <span>KYC/AML compliant, with banking-grade security and crypto-friendly policies.</span>
        <p className="list">Lower Fees Than Traditional Banks</p>
        <span>Save on international transfers, account maintenance, and currency conversions.</span>
      </>
    ),
  },
  {
    title: "What Are the Requirements to Open a Crypto IBAN Account?",
    content: (
      <>
        <p>
          Opening a crypto IBAN account is a straightforward process, but it involves a few essential steps to ensure compliance and
          security:
        </p>
        <p className="list">Proof of Identity and Address</p>
        <span>
          To comply with regulatory standards, we require all clients to complete a Know Your Customer (KYC) process. This involves
          submitting a valid government-issued ID (such as a passport or driver’s license) and a proof of address document — typically a
          recent utility bill, bank statement, or official correspondence dated within the last 3 months.
        </span>
        <p className="list">Full Account Verification</p>
        <span>
          Before your crypto IBAN can be activated, we require full account verification. This includes linking a valid payment method (such
          as a bank account or card) and enabling two-factor authentication (2FA) to ensure the highest level of security for your
          transactions and data.
        </span>
        <p className="list">Declaration of Purpose</p>
        <span>
          As part of our compliance process, we kindly request all applicants to provide a brief declaration of purpose when opening a
          crypto IBAN account. This helps us better understand your intended use — whether it’s for international transfers, business
          payments, investment-related activity, or other financial operations. This step ensures smooth onboarding and regulatory
          alignment.
        </span>
        <p className="list">One-Time Account Setup Fee</p>
        <span>
          To activate your dedicated crypto IBAN, a one-time setup fee is required. This fee — typically around 100 EUR — covers the
          administrative processing, compliance checks, and activation of your account for SEPA/SWIFT transactions. The exact amount may
          vary depending on the service package selected.
        </span>
      </>
    ),
  },
]
